import ListMonthlyInvoiceTable from "../../Dashboard/ListInvoice/ListMonthlyInvoice";
import SalesChangeGraph from "../../Dashboard/SalesChange/SalesChange";
import StaffInfoChartComponent from "../../Dashboard/StaffInfoChart/StaffInfoChart";
import WarehouseInfoComponent from "../../Dashboard/WarehouseInfo/WarehouseInfo";
import styles from "./index.module.scss";


const Dashboard = () => {
  return (
    <div className={styles.pageContent}>
      <div className={styles.dashboardTitle}>
        <h2>ダッシュボード</h2>
      </div>
      <ListMonthlyInvoiceTable/>
      <SalesChangeGraph/>
      <StaffInfoChartComponent/>
      <WarehouseInfoComponent/>
    </div>
  )
}

export default Dashboard;